import React, { useState } from 'react';
// import { ImagenUser } from './ImagenUser'
import { useSelector } from 'react-redux';
import { DrawerMenu } from './DrawerMenu';
import { getInitials } from '../../common/getInitials';
import { DrawerProfileUser } from '../../pages/profile/drawerProfileUser/DrawerProfileUser';
import { DrawerPaymentStudent } from '../../pages/payments/drawerPaymentStudent/DrawerPaymentStudent';

export const ButtonUserMenu = () => {
    const { user } = useSelector((state) => state.user);
    const connected = useSelector((state) => state.chatRealtime.connected);
    const [isOpenDrawerMenu, setIsOpenDrawerMenu] = useState(false);
    const [isOpenDrawerProfile, setIsOpenDrawerProfile] = useState(false);
    const [isOpenDrawerPayment, setIsOpenDrawerPayment] = useState(false);

    const toggleDrawerFilters = () => {
        setIsOpenDrawerMenu((prevState) => !prevState);
    }

    const toggleDrawerProfile = () => {
        setIsOpenDrawerProfile((prevState) => !prevState);
    }

    const toggleDrawerPayment = () => {
        setIsOpenDrawerPayment((prevState) => !prevState);
    }

    const handleOpenProfile = () => {
        setIsOpenDrawerProfile(true);
    }

    const handleOpenPaymentDrawer = () => {
        setIsOpenDrawerPayment(true);
    }

    const { firstName, lastName, _id: userLoggedId } = user;

    return (
        <>
            <button
                onClick={() => toggleDrawerFilters()}
                className="flex max-w-xs items-center rounded-full text-sm ring-4 ring-gray-200 focus:shadow-lg focus:shadow-indigo-950/20 focus:ring-indigo-100 transition-all duration-300 hover:ring-indigo-200 focus:outline-none"
            >
                <span className="sr-only">Open user menu</span>
                <div className='relative w-16 h-16 rounded-full border-3 border-white shadow-lg bg-gradient-to-br from-indigo-400 to-purple-500 flex items-center justify-center'>
                    <span className='text-white text-[1.8rem] font-bold'>
                        {getInitials(firstName, lastName)}
                    </span>
                    <span
                        title={connected ? 'En línea' : 'Desconectado'}
                        className={`absolute bottom-0.5 right-0.5 flex h-4 w-4 items-center justify-center rounded-full ring-2 ring-white ${connected ? 'bg-green-500' : 'bg-gray-400'}`}
                    >
                        {connected && (
                            <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-green-400 opacity-75" />
                        )}
                    </span>
                </div>
            </button>
            <DrawerMenu
                isOpenDrawerMenu={isOpenDrawerMenu}
                toggleDrawerFilters={toggleDrawerFilters}
                onOpenProfile={handleOpenProfile}
                onOpenPaymentDrawer={handleOpenPaymentDrawer}
            />
            <DrawerProfileUser
                isOpenDrawerProfile={isOpenDrawerProfile}
                toggleDrawerProfile={toggleDrawerProfile}
                userId={userLoggedId}
                refreshTable={false}
            />
            <DrawerPaymentStudent
                isOpenDrawerPayment={isOpenDrawerPayment}
                toggleDrawerPayment={toggleDrawerPayment}
                userId={userLoggedId}
            />
        </>

    )
}
